<template>
    <Card :title="$t('crm-setting.pipeline.step.list')" containerClass="mb-5">
      <template #cardToolbar>
        <div class="d-flex justify-content-end align-items-center">
          <div>
            <Button v-if="$can(abilities.CREATE_OPPORTUNITY_STATE)" btn-class="me-3 btn-sm" type="new" btn-text="crm-setting.pipeline.step.create" @click.prevent="openStepModal"></Button>
          </div>
        </div>
      </template>
      <template #cardBody>
        <InfoAlert :text="$t('crm-setting.pipeline.step.alert_text')"/>
        <div class="row">
            <Draggable :title1="$t('crm-setting.pipeline.step.title2')" :title2="$t('crm-setting.pipeline.step.title1')" @change="handleChange" @statusChange="handleStatusChange">
              <template #container1>
                <div
                  v-for="item in inactiveSteps" 
                  :key="item.id" 
                  :data-id="item.id"
                  class="draggable"
              >
                <StepItem containerClass="mb-2" :label="item.name" @actionUpdate="updateStep(item)" @actionDelete="deleteStep(item.id)"/>
              </div>
            </template>
            <template #container2>
              <div
                  v-for="item in activeSteps"
                  :key="item.id"
                  :data-id="item.id"
                  class="draggable"
              >
                <StepItem containerClass="mb-2" :label="item.name" @actionUpdate="updateStep(item)" @actionDelete="deleteStep(item.id)"/>
              </div>
            </template>
          </Draggable>
        </div>
      </template>
    </Card>

    <CreateStep id="create" @load="loadData"></CreateStep>  
    <CreateStep id="edit" :isEdit="true" :step="formUpdateData" @load="loadData"></CreateStep>
</template>

<script setup>
import {ref, onMounted, computed} from 'vue'
import CreateStep from "@/Modules/CRM/components/Modals/Step/CreateStep.vue";
import StepItem from "@/Modules/CRM/components/StepItem";
import Draggable from "@/Modules/CRM/components/Draggable";
import {useStore} from "vuex";
import i18n from "@/plugins/i18n";
import Button from "@/components/Button";
import InfoAlert from "@/components/InfoAlert"
import Card from "@/Modules/CRM/components/Card";
import {useSwal} from "@/composables/useSwal";
import abilities from "@/composables/abilities";

const store = useStore()
const {showSwal} = useSwal()

const formUpdateData = ref({
  opportunity_state_id: '',
  id: '',
  name: '',
  criterias: [],
  apply_to_older: false,
  active: true
})

const steps = computed(() => store.getters['steps/getSteps'])
const activeSteps = computed(() => Object.values(steps.value).filter((item) => item && item.active == true))
const inactiveSteps = computed(() => Object.values(steps.value).filter((item) => item && item.active == false))

function openStepModal (){
  $('#createStepModal_create').modal('toggle')
}

function updateStep(item){
  formUpdateData.value.opportunity_state_id = item.id
  formUpdateData.value.id = item.id
  formUpdateData.value.name = item.name
  formUpdateData.value.apply_to_older = item?.apply_to_older ?? false
  formUpdateData.value.active = item?.active ?? false
  formUpdateData.value.criterias = item?.criterias.map(el => ({id: el?.id, title: el?.title})) ?? []
  $('#createStepModal_edit').modal('toggle')
}

async function deleteStep(id){
  showSwal(
    i18n.global.t('crm-setting.pipeline.step.swal.title'),
    i18n.global.t('crm-setting.pipeline.step.swal.deleted')
  ).then( async (result) => {
    if (result.value) {
      try {
        await store.dispatch('steps/deleteStep', id)
        loadData()
        window.toastr['success'](i18n.global.t("notification.step_deleted"))
      }catch (e) {
      }
    }
  });
}

function handleChange({ id, newIndex }) {
  let data = Object.values(steps.value).filter((item) => item.id == id)
  let form = {
    opportunityState: data[0].id,
    new_order: newIndex + 1
  }

  store.dispatch('steps/updateStepOrder', form)
      .then((response) => {
          window.toastr['success'](i18n.global.t('notification.step_changed_position'))
      })
}

function handleStatusChange(id) {
  store.dispatch('steps/updateStepStatus', {id})
      .then((response) => {
          window.toastr['success'](i18n.global.t('notification.step_changed_status'))
      })
}

function loadData(){
  store.dispatch('steps/loadSteps')
}

onMounted(() => {
  loadData()
})
</script>